import { toNumber, WebsocketBidEvent } from '@freelancer/datastore/core';
import { BidApi } from 'api-typings/projects/projects';
import { Bid } from './bids.model';

export function transformBid(bid: BidApi): Bid {
  if (!bid.submitdate) {
    throw new ReferenceError(`Bid missing submitdate.`);
  }

  return {
    id: bid.id,
    bidderId: bid.bidder_id,
    projectId: bid.project_id,
    retracted: bid.retracted,
    amount: bid.amount,
    period: bid.period,
    description: bid.description,
    projectOwnerId: bid.project_owner_id,
    submitDate: bid.submitdate * 1000,
    // buyerProjectFee?: Fee;
    timeSubmitted: bid.time_submitted ? bid.time_submitted * 1000 : undefined,
    highlighted: bid.highlighted,
    sponsored: bid.sponsored,
    milestonePercentage: bid.milestone_percentage,
    awardStatusPossibilities: bid.award_status_possibilities,
    awardStatus: bid.award_status,
    paidStatus: bid.paid_status,
    completeStatus: bid.complete_status,
    timeAwarded: bid.time_awarded,
    frontendBidStatus: bid.frontend_bid_status,
    hiremeCounterOffer: bid.hireme_counter_offer,
    shortlisted: bid.shortlisted,
    score: bid.score,
    // negotiatedOffer?: NegotiatedOfferApi;
    hidden: bid.hidden,
    hiddenReason: bid.hidden_reason,
    timeAccepted: bid.time_accepted,
    paidAmount: bid.paid_amount,
    hourlyRate: bid.hourly_rate,
  };
}

export function transformWebsocketBidEvent(event: WebsocketBidEvent): Bid {
  return {
    id: toNumber(event.data.id),
    bidderId: toNumber(event.data.userId),
    projectId: toNumber(event.data.projectId),
    amount: toNumber(event.data.amount),
    period: toNumber(event.data.period),
    description: event.data.bid.descr || undefined,
    submitDate: event.data.bid.submitdate_ts
      ? event.data.bid.submitdate_ts * 1000
      : 0,
    highlighted: event.data.bid.highlighted || false,
    milestonePercentage: toNumber(event.data.bid.milestone_percentage),
    shortlisted: event.data.bid.isShortlisted || false,
    score: event.data.bid.score,
    hidden: event.data.bidHidden,
  };
}
